<template>
    <section class="hero-dark">
        <div class="container">
            <div class="hero-content">
                <!-- Columna izquierda: Texto -->
                <div class="hero-left">
                    <h1 class="hero-greeting">
                        Hola<span class="dot">.</span>
                    </h1>
                    <h2 class="hero-intro">Soy {{ firstName }}</h2>
                    <h3 class="hero-title">{{ title }}</h3>

                    <!-- Botones CTA -->
                    <div class="hero-buttons">
                        <a href="#contact" @click.prevent="scrollToSection('contact')" class="btn-primary">
                            Contáctame
                        </a>
                        <a v-if="cvUrl" :href="cvUrl" class="btn-secondary" download="cv-oscar-sanchez.pdf">
                            <i class="fa fa-download"></i> Descargar CV
                        </a>
                    </div>

                    <!-- Tecnologías -->
                    <div class="hero-techs">
                        <span v-for="tech in mainTechs" :key="tech" class="tech-item">
                            {{ tech }}
                        </span>
                    </div>
                </div>

                <!-- Columna derecha: Foto -->
                <div class="hero-right">
                    <div class="hero-image-wrapper">
                        <div class="image-circle">
                            <img :src="imgProfile" :alt="name" class="hero-image">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <a href="#about" @click.prevent="scrollToSection('about')" class="scroll-down" aria-label="Bajar a la siguiente sección">
            <i class="fa fa-chevron-down"></i>
        </a>
    </section>
</template>

<script>
export default {
    name: 'HeroSectionDark',
    props: {
        name: String,
        title: String,
        imgProfile: String,
        cvUrl: String,
        mainTechs: Array
    },
    computed: {
        firstName() {
            return this.name ? this.name.split(' ')[0] : '';
        }
    },
    methods: {
        scrollToSection(id) {
            const element = document.getElementById(id);
            if (element) {
                const offset = 80;
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - offset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        }
    }
}
</script>

<style scoped>
.hero-dark {
    background: transparent;
    min-height: 100vh;
    display: flex;
    align-items: center;
    padding: 80px 0;
    position: relative;
}

.hero-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 60px;
    align-items: center;
}

/* Columna izquierda */
.hero-left {
    color: #fff;
}

.hero-greeting {
    font-size: 48px;
    font-weight: 400;
    color: #fff;
    margin: 0 0 10px 0;
    line-height: 1;
}

.hero-greeting .dot {
    color: #ff6b6b;
    font-weight: 700;
}

.hero-intro {
    font-size: 56px;
    font-weight: 300;
    color: #fff;
    margin: 0 0 10px 0;
    line-height: 1.1;
    position: relative;
    padding-left: 15px;
}

.hero-intro::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    background: #ff6b6b;
}

.hero-title {
    font-size: 56px;
    font-weight: 700;
    color: #fff;
    margin: 0 0 40px 0;
    line-height: 1.1;
}

.hero-buttons {
    display: flex;
    gap: 20px;
    margin-bottom: 60px;
}

.btn-primary {
    background: #ff6b6b;
    color: #fff;
    border: none;
    padding: 16px 32px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 0;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
    display: inline-block;
}

.btn-primary:hover {
    background: #ff5252;
    transform: translateY(-2px);
}

.btn-secondary {
    background: #1a1d29;
    color: #fff;
    border: 2px solid #fff;
    padding: 14px 32px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 0;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
    display: inline-block;
}

.btn-secondary:hover {
    background: #fff;
    color: #1a1d29;
}

.hero-techs {
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
}

.tech-item {
    color: rgba(255, 255, 255, 0.4);
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0.5px;
}

/* Columna derecha */
.hero-right {
    display: flex;
    justify-content: center;
    align-items: center;
}

.hero-image-wrapper {
    position: relative;
}

.image-circle {
    width: 500px;
    height: 500px;
    overflow: visible;
    position: relative;
    z-index: 2;
}

.hero-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center 20%;
    border-radius: 24px;
    box-sizing: border-box;
    box-shadow: 0 0 0 12px #1a1d29, 0 0 0 13px rgba(255, 255, 255, 0.1), 0 20px 60px rgba(0, 0, 0, 0.5);
}

/* Flecha de scroll */
.scroll-down {
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    color: rgba(255, 255, 255, 0.5);
    font-size: 22px;
    text-decoration: none;
    animation: scrollBounce 2s ease-in-out infinite;
    transition: color 0.3s ease;
}

.scroll-down:hover {
    color: #ff6b6b;
}

@keyframes scrollBounce {
    0%, 100% {
        transform: translate(-50%, 0);
        opacity: 0.6;
    }
    50% {
        transform: translate(-50%, 10px);
        opacity: 1;
    }
}

@media (prefers-reduced-motion: reduce) {
    .scroll-down {
        animation: none;
    }
}

/* Responsive */
@media (max-width: 1024px) {
    .scroll-down {
        display: none;
    }

    .hero-dark {
        min-height: auto;
        padding: 60px 0;
    }

    .hero-content {
        grid-template-columns: 1fr;
        gap: 40px;
        text-align: center;
    }

    .hero-intro::before {
        display: none;
    }

    .hero-buttons {
        justify-content: center;
    }

    .hero-techs {
        justify-content: center;
        margin-bottom: 50px;
    }

    .image-circle {
        width: 350px;
        height: 350px;
    }

    .hero-greeting {
        font-size: 40px;
        margin-top: 50px;
    }

    .hero-intro,
    .hero-title {
        font-size: 42px;
    }
}

@media (max-width: 768px) {
    .hero-dark {
        padding: 60px 0;
    }

    .hero-greeting {
        font-size: 32px;
    }

    .hero-intro,
    .hero-title {
        font-size: 32px;
    }

    .hero-buttons {
        flex-direction: column;
        gap: 15px;
    }

    .btn-primary,
    .btn-secondary {
        width: 100%;
        text-align: center;
    }

    .hero-techs {
        margin-bottom: 30px;
    }

    .image-circle {
        width: 300px;
        height: 300px;
    }

    .tech-item {
        font-size: 14px;
    }
}
</style>
